export const popupOverlayClassNames = [
    '@fixed',
    '@inset-0',
    '@z-[1001]',
    '@bg-[rgba(0,0,0,0.36)]',
    'data-[state=open]:@animate-in',
    'data-[state=closed]:@animate-out',
    'data-[state=closed]:@fade-out-0',
    'data-[state=open]:@fade-in-0'
];
export const popupContentClassNames = [
    '@fixed',
    '@z-[1001]',
    '@left-[50%]',
    '@top-[50%]',
    '@translate-x-[-50%]',
    '@translate-y-[-50%]',
    '@w-[calc(100vw-2rem)]',
    'sm:@w-auto',
    'sm:@min-w-[420px]',
    'sm:@max-w-[880px]',
    '@rounded-lg',
    'sm:@border',
    'sm:@border-grey-2_5',
    '@bg-grey-2-b',
    '@shadow-down8',
    '@duration-200',
    'data-[state=open]:@animate-in',
    'data-[state=closed]:@animate-out',
    'data-[state=closed]:@fade-out-0',
    'data-[state=open]:@fade-in-0',
    'data-[state=closed]:@zoom-out-95',
    'data-[state=open]:@zoom-in-95',
    'data-[state=closed]:@slide-out-to-left-1/2',
    'data-[state=closed]:@slide-out-to-top-[48%]',
    'data-[state=open]:@slide-in-from-left-1/2',
    'data-[state=open]:@slide-in-from-top-[48%]',
];
export const popupHeaderClassNames = [
    '@flex',
    '@h-12',
    '@items-center',
    '@pl-6',
    '@pr-4',
    '@py-2',
    '@border-b',
    '@border-b-grey-2_3',
    '@bg-grey-25-b',
    '@rounded-t-lg',
    '@select-none',
];
export const popupCloseClassNames = [
    '@ml-auto',
    '@p-2',
    '@leading-[0]',
    '@rounded',
    '@text-grey-6',
    'hover:@bg-grey-2',
    'focus:@outline-none',
    'focus:@ring-2',
    'focus:@ring-ring',
    'focus:@ring-offset-2',
    'disabled:@pointer-events-none',
];
export const popupTitleClassNames = [
    '@text-grey-6',
    '@text-t2',
    '@font-medium',
    '@mb-0',
];
export const popupDescriptionClassNames = [
    '@ml-1',
    '@text-grey-4_5',
    '@text-caption',
    '@self-end',
    '@mb-1',
];
export const popupFooterClassNames = [
    '@flex',
    '@flex-row-reverse',
    '@mt-3',
    'sm-only:@overflow-hidden',
    'sm-only:@rounded-b-lg',
    'sm-only:[&>button]:@flex-auto',
    'sm-only:[&>button]:@rounded-none',
    'sm-only:[&>button]:@border-none',
    'sm:@mb-5',
    'sm:@mx-6',
    'sm:@justify-start',
    'sm:@space-x-reverse',
    'sm:@space-x-2',
    'sm:@space-y-0',
];
export var PopupCloseIntent;
(function (PopupCloseIntent) {
    PopupCloseIntent["Action"] = "action";
    PopupCloseIntent["Cancel"] = "cancel";
})(PopupCloseIntent || (PopupCloseIntent = {}));
